module.exports = require("./hyphen.js");
